function handleFilterClick(e){
    e.preventDefault();
    
    // Check if on tag selection, there are other filter active in the format
    // ?p.filter
    // and add to the new url
    const url = this.getAttribute('data-custom-filter-option');
    const {search} = window.location;

    if (search.length > 0)
        window.location.assign(url+search)
    else
        window.location.assign(url);
}

function handleClickOnCollapseButton(){
    const container = this.closest('form.filter-form');
    if (!container) return;
    
    const triggers = container.querySelectorAll('button.collapsible-trigger[aria-expanded=true]');
    if(triggers.length < 1) return;
    
    triggers.forEach(trigger => {
        if (trigger !== this) {
            trigger.setAttribute('aria-expanded','false');
            trigger.classList.remove('is-open');
        }
    })   
}

function hideCollectionGroupFilter(){
    const filtersGroup = window.document.querySelectorAll('form.filter-form > div[class*="collection-sidebar__group--"]');
    if(filtersGroup.length < 1) return;
    filtersGroup.forEach(group => {
        const tagList = group.querySelector('ul.no-bullets.tag-list');
        if (tagList){
            const childrens = tagList.children;
            let child, hiddenChildCunt = 0;
            for ( child of childrens){
                if(child.classList.contains('hide')) hiddenChildCunt++;
            }
            if (hiddenChildCunt === childrens.length) group.style.display = 'none';
            
            
        }
    })
}

window.addEventListener('load',function(){
    const customFilterOptions = window.document.querySelectorAll('a[data-custom-filter-option]');
    const filterCollapseTriggers = window.document.querySelectorAll('.collapsible-trigger');
    
    if (customFilterOptions.length > 0){
        customFilterOptions.forEach(option => {
            option.addEventListener('click',handleFilterClick);
        })
    }

    if (filterCollapseTriggers.length > 0){
        filterCollapseTriggers.forEach(trigger=>{
            trigger.addEventListener('click',handleClickOnCollapseButton);
        })
    }

    hideCollectionGroupFilter();

});
window.document.addEventListener('collection:reloaded',function(){
    const customFilterOptions = window.document.querySelectorAll('a[data-custom-filter-option]');
    const filterCollapseTriggers = window.document.querySelectorAll('.collapsible-trigger');

    if (customFilterOptions.length > 0){
        customFilterOptions.forEach(option => {
            option.addEventListener('click',handleFilterClick);
        })
    }

    if (filterCollapseTriggers.length > 0){
        filterCollapseTriggers.forEach(trigger=>{
            trigger.addEventListener('click',handleClickOnCollapseButton);
        })
    }

    hideCollectionGroupFilter();
})